import { createContext, useMemo } from 'react';
import ApiClient from './Index';
import ErrorBoundary from './ServerLogging.js';

/* global chrome */

export const GlobalContext = createContext();
export const GlobalProvider = ({ children }) => {
  // Create ApiClient using useMemo to ensure that the same instance is returned on every render.
  const apiClient = useMemo(() => {
    const client = new ApiClient();
    return client;
  }, []); // Empty dependency array means the apiClient will be created only once.

  // Render the provider for the GlobalContext, making the apiClient available to child components.
  return (
    <GlobalContext.Provider value={{ apiClient }}>
      <ErrorBoundary apiClient={apiClient}>{children}</ErrorBoundary>
    </GlobalContext.Provider>
  );
};

// const { apiClient } = useContext(GlobalContext);
